export default __webpack_public_path__ + "static/media/check.449e65b3.svg";